//* Libraries imports
import { useMutation } from "@tanstack/react-query";

//* Axios Import
import { formDataApi } from "../../../services/apis/configs/apiClient";

//* Schemas imports
import type { UpdateResourceQuestion } from "../../../schemas/common/resource/question/resource-question";
import { responseUpdateSchema } from "../../../schemas/api-response";


/**
 * Hook to update a resource question.
 */
async function updateResourceQuestion({
    processoId,
    questionId,
    data,
    files
}: {
    processoId: string;
    questionId: string;
    data: UpdateResourceQuestion;
    files: File[];
}) {
    try {
        const url = `/student_portal/private/${processoId}/recursos/questoes/${questionId}`;
        const formData = new FormData();        for (const [key, value] of Object.entries(data)) {
        // Pular valores undefined ou null
        if (value === undefined || value === null) {
            continue;
        }
        
        if (key === 'numero_questoes') {
            formData.append('numero_questoes', JSON.stringify(value));
        } else if (key === 'files_exists') {
            // Garantir que files_exists seja um array antes de enviar
            if (Array.isArray(value)) {
                formData.append('files_exists', JSON.stringify(value));
            }
        } else {
            formData.append(key, String(value));
        }
        }
    
        if (files && files.length > 0) {
        files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
        });
        }
    
        const response = await formDataApi.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
        });
    
        return responseUpdateSchema.parse(response);
    } catch (error) {
        throw error;
    }
    }


/**
 * Mutation hook for updating a resource question.
 */
export function useUpdateResourceQuestion() {
    return useMutation({
        mutationFn: updateResourceQuestion,
        onError: (error) => {
            console.error("Error updating resource question:", error);
        },
    });
}